import React, { useState, useEffect } from "react";
import "./Stats.css";

const StatItem = ({ iconClass, value, label, bgClass, isArea }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000; // 2 saniye
    const increment = Math.ceil(value / (duration / 50));

    const counter = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(counter);
      } else {
        setCount(start);
      }
    }, 30); // Her 30ms'de bir artır
    return () => clearInterval(counter);
  }, [value]);

  return (
    <div
      className={`stat-item text-center col-12 col-md-6 col-lg-3 ${bgClass}`}
    >
      <div className="icon-container mb-2 m-auto">
        <i className={`fas ${iconClass}`}></i>
      </div>
      <h3 className="stat-value m-auto">
        +{count}{" "}
        {isArea && (
          <span>
            m<span className="sup">2</span>
          </span>
        )}
      </h3>
      <p className="stat-label">{label}</p>
    </div>
  );
};

const Stats = () => {
  return (
    <div className="bg-light py-3 mb-5">
      <div className="container-xxl">
        <div className="stats d-flex justify-content-around row">
          <StatItem
            iconClass="fa-home"
            value={50}
            label="Yapı Portföyü"
            bgClass="bg-white"
            isArea={false}
          />
          <StatItem
            iconClass="fa-users"
            value={10}
            label="Lokasyon"
            bgClass=""
            isArea={false}
          />
          <StatItem
            iconClass="fa-helmet-safety"
            value={9000}
            label="Proje Alanı"
            bgClass="bg-white"
            isArea={true}
          />
          <StatItem
            iconClass="fa-star"
            value={25}
            label="Kullanıma Hazır Yapı"
            bgClass=""
            isArea={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Stats;
